import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PhoneGradeWithSkuComponent } from './phone-grade-with-sku.component';
import { RouterModule } from '@angular/router';
import { TooltipModule } from 'ng2-tooltip-directive';
import {
  MatInputModule, MatPaginatorModule, MatProgressSpinnerModule,
  MatSortModule, MatTableModule
} from "@angular/material";
import { UiSwitchModule } from 'ngx-ui-switch';
import { MyDatePickerModule } from 'mydatepicker';

const routerConfig = [{
  path: '',
  component: PhoneGradeWithSkuComponent
}];

@NgModule({
  imports: [
    CommonModule, FormsModule, TooltipModule, MyDatePickerModule,
    MatTableModule, MatSortModule, MatInputModule, MatPaginatorModule, MatProgressSpinnerModule, ReactiveFormsModule,
    RouterModule.forChild(routerConfig),
    UiSwitchModule
  ],
  declarations: [
    PhoneGradeWithSkuComponent
    //TruncatePipe
  ],
  exports: [
    PhoneGradeWithSkuComponent, MatSortModule
  ],
  providers: []

})

export class PhoneGradeWithSkuModule { }
